module.exports = __webpack_public_path__ + "static/post-c8e1a6bbcb5f6d24b7b3d3a65e83b0af.jpg";